import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { ActionEventsEnum } from '@toro/common/shared/enum/tracking/action-events.enum';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { ConsolidatedPosition } from '@toro/common/shared/models/pos-risk/consolidated-position';
import { FinancePosition } from '@toro/common/shared/models/pos-risk/finance-position';
import { FinanceActions } from '@toro/common/shared/state-management/finance/finance.action';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';
import { Subscription } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { DebitBalanceService } from './../../../../services/toro-lumen/debit-balance.service';

@Component({
  selector: 'position',
  templateUrl: './position.component.html',
  styleUrls: ['./position.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PositionComponent implements OnInit {

    @Input() public positionBoxTitle: string;
    @Input() public positionBoxType: string;

    public finance: FinancePosition;
    public consolidatedPosition: ConsolidatedPosition;
    public totalGuarantee: number;
    public currentAccountBalance: number;
    public totalRequiredGuaranteeFactor: number;
    public projectedBalance: number;
    public futureBalance: number;
    public doesNotHasEngoughBalance: boolean;
    public hasEnoughBalance: boolean;
    public finedToday: boolean;
    public debitBalance: number;
    private disposableSubscriptions: Subscription[] = [];
    public userCblc: string;

  public tooltipLeverageRatio: string = `
      <div>
        <p style="margin-bottom: 8px;">Esse é o valor que mede sua alavancagem em relação ao seu patrimônio. </p>
        <ul style="list-style: disc; padding-left: 20px; margin-bottom: 8px;">
          <li><strong>0% a 99%:</strong> você não está alavancado.</li>
          <li><strong>100% a 169%:</strong> você está alavancado.</li>
          <li><strong>170% ou mais:</strong> alto nível de alavancagem. Suas posições poderão ser encerradas compulsoriamente.</li>
        </ul>
        <div class="limit-tooltip-bottom-warning" style="margin-top: 8px;">
          <a href="https://blog.toroinvestimentos.com.br/trading/alavancagem-o-que-e-como-funciona" target="_blank"> Saiba mais sobre a Alavancagem </a>
          <img src="stock/assets/icons/arrow-line-right.svg" alt="">
        </div>
      </div>
    `;

    public tooltipGuaranteeDisclaimer: string = `
      <div>
        <p class="pop-content">Esse é o limite que pode ser utilizado para operações em renda variável quando não houver saldo suficiente em sua conta corrente. </p>
        <div class="limit-tooltip-bottom-warning">
          <a href="https://blog.toroinvestimentos.com.br/trading/margem-de-garantia-o-que-e/" target="_blank"> Saiba mais sobre Margem de Garantia </a>
          <img src="stock/assets/icons/arrow-line-right.svg" alt="">
        </div>
      </div>
    `;

    public constructor(
        private store: Store<AppState>,
        private debitBalanceService: DebitBalanceService
    ) {
      this.dispatchFinance();
      this.initUserCblcListener();
    }

    public ngOnInit(): void {
      this.disposableSubscriptions.push(
          this.store
            .select((financeStore) => financeStore.finance.consolidatePosition)
            .pipe(filter((consolidatedPosition) => !!consolidatedPosition))
            .subscribe((consolidatedPosition: ConsolidatedPosition) => {
              this.consolidatedPosition = consolidatedPosition;
              this.totalGuarantee = consolidatedPosition.totalOperationGuarantee - Math.abs(consolidatedPosition.accountBalance)
              this.totalRequiredGuaranteeFactor = consolidatedPosition.totalRequiredGuaranteeFactor;
            }
            ),
            this.store.select((store) => store.finance)
            .subscribe((finance) => {
              this.finance = finance.finance;
              this.currentAccountBalance = this.finance.currentFinancialBalance;
              this.projectedBalance = this.finance.projectedD1 + this.finance.projectedD2 + this.finance.projectedD3;
              this.futureBalance = this.currentAccountBalance + this.projectedBalance;
          })

      );

      this.debitBalanceService.getDebitBalance().pipe(
        tap((balance) => {
          this.debitBalance = balance.data.value;
          this.finedToday = balance.data.finedToday;
        })
      ).subscribe();
    }

    public dispatchFinance() {
        this.store.dispatch({ type: FinanceActions.getRealtimeConsolidatedPosition });
        this.store.dispatch({ type: FinanceActions.getRealtimeFinancePosition });
    }

    public initUserCblcListener() {
      this.store.select((state) => state.authentication.currentUser)
        .filter((data) => !!data && !!data.cblc)
        .first()
        .subscribe((data) => {
          this.userCblc = data.cblc;
        });
  }

    public sendTracking(event: string, breakdowns: any) {
      this.store.dispatch({
          type: TrackingActions.trackEvents,
          payload: { type: event, events: breakdowns },
      });
    }

    public sendTooltipTracking(origin: string) {
      this.sendTracking(ActionEventsEnum.ELEMENT_CLICKED, {
        'Product Area Origin': 'Bolsa',
        'Element': 'Tooltip índice de alavancagem',
        'Group': 'Card day trade e swing trade',
        'Time Responsavel': 'Roebling',
        'Step': 'Garantias',
      });
    }
}
